/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    // ICommerceApiSettings,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getStockAvailQtyAsync } from './DataService/DataActionExtension.g'; //getStockAvailDateAsync, getPromiseDateAsync
import { IGetPromiseStockAvailQtyResponse } from './DataService/DataServiceEntities.g';
// import { getStockAvailQtyInput } from './DataService/DataActionExtension.g';

/**
 * Getstockavailqty Input Action
 */
export class GetstockavailqtyInput implements IActionInput {
    // Input properties
    public accountNum: number;
    public catalogId: number;
    public itemId: string;
    public dispositionCode: string;
    public itemQuantity: string;
    public userName: string;

    // TODO: Construct the input needed to run the action
    constructor(
        accountNum: number | string,
        catalogId: number | string,
        itemId: string,
        dispositionCode: string,
        itemQuantity: string,
        userName: string
    ) {
        this.accountNum = typeof accountNum === 'string' ? +accountNum : accountNum;
        this.catalogId = typeof catalogId === 'string' ? +catalogId : catalogId;
        this.itemId = itemId;
        this.dispositionCode = dispositionCode;
        this.itemQuantity = itemQuantity;
        this.userName = userName;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetstockavailqtyInput`;
    public getCacheObjectType = () => 'GetstockavailqtyInput';
    public dataCacheType = (): CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetstockavailqtyData {
    QtyAvail: number;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
    args: ICreateActionContext,
    accountNum: number | string,
    catalogId: number | string,
    itemId: string,
    dispositionCode: string,
    itemQuantity: string,
    userName: string
): IActionInput => {
    return new GetstockavailqtyInput(accountNum, catalogId, itemId, dispositionCode, itemQuantity, userName);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */

// async function action(input: GetstockavailqtyInput, ctx: IActionContext): Promise<IGetstockavailqtyData> {
//     // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

//     // // TODO: Uncomment the below line to get the value from a service
//     // const response = await Msdyn365.sendRequest<IGetstockavailqtyData[]>('/get/example/id/1', 'get');
//     // //return { text: 'Static data from action' };
//     // return response;
//     return getStockAvailQtyAsync({ callerContext: ctx }, input.accountNum, input.catalogId, input.itemId, input.dispositionCode)
//         .then(data => {
//             return { QtyAvail: data };
//         })
//         .catch(error => {
//             ctx.telemetry.exception(error);
//             ctx.trace('[get-stock-avail-qty] Unable to load stock total');
//             throw new Error('[get-stock-avail-qty] Unable to load stock total');
//         });
// }

export async function Getstockavailqty(input: GetstockavailqtyInput, ctx: IActionContext): Promise<IGetPromiseStockAvailQtyResponse> {
    return getStockAvailQtyAsync(
        { callerContext: ctx },
        input.itemId,
        input.accountNum,
        input.catalogId,
        input.dispositionCode,
        input.itemQuantity,
        input.userName
    )
        .then(data => {
            if (data.QtyAvail > 0 && (data.QtyAvail * 100) % 1 !== 0) {
                data.QtyAvail = Math.round(data.QtyAvail * 100) / 100;
            }
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-stock-avail-qty] Unable to load stock total');
            throw new Error('[get-stock-avail-qty] Unable to load stock total');
        });
    // return 999;
}

export default createObservableDataAction({
    action: <IAction<IGetPromiseStockAvailQtyResponse>>Getstockavailqty,
    id: 'Getstockavailqty',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
